import { createSelector } from 'reselect';
import { AppState } from 'src/store/state';
import { SignUpPageState } from './state';
import { plainToClassFromExist } from 'class-transformer';
import { ServerError } from '../../../entities/server-errors';
import { User } from '../../../entities/user';
import { DTOGroup } from '../../../enums/dto-group';

const selectFeature = (state: AppState): SignUpPageState => state.pages.signUp;

export class SignUpPageSelectors {
  public static isSubmitting = createSelector(
    selectFeature,
    (state) => state.isSubmitting
  );

  public static error = createSelector(
    selectFeature,
    (state) => plainToClassFromExist(
      new ServerError<User>(User),
      state.error,
      {
        groups: [DTOGroup.MAIN],
        strategy: 'excludeAll'
      }
    ) as ServerError<User>
  );
}
